
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","viewBox":"0 0 22 22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_5613_21998)"}},[_c('path',{attrs:{"d":"M18.333 2.75H20.1663V8.25H18.333V4.58333H14.6663V2.75H18.333ZM3.66634 2.75H7.33301V4.58333H3.66634V8.25H1.83301V2.75H3.66634ZM18.333 17.4167V13.75H20.1663V19.25H14.6663V17.4167H18.333ZM3.66634 17.4167H7.33301V19.25H1.83301V13.75H3.66634V17.4167Z","fill":"currentColor"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_5613_21998"}},[_c('rect',{attrs:{"width":"22","height":"22","fill":"currentColor"}})])])])
          )
        }
      }
    